import { BaseModel } from '../../_base/crud';

export class TagsModel extends BaseModel {

	name: string
    id:string
	clear() {

	this.name = ''
    this.id = ''
	}
}





